/** После успешного POST /api/users/create разрешаем маршруты игры (защита от «залипшего» userInfo админки). */
export const STUDENT_EXAM_SESSION_KEY = 'student_exam_signed_in';

export function clearStudentExamSession() {
  sessionStorage.removeItem(STUDENT_EXAM_SESSION_KEY);
}

export function markStudentExamSignedIn() {
  sessionStorage.setItem(STUDENT_EXAM_SESSION_KEY, '1');
}

export function isStudentExamSignedIn() {
  return sessionStorage.getItem(STUDENT_EXAM_SESSION_KEY) === '1';
}
